import { render, staticRenderFns } from "./landingPages.vue?vue&type=template&id=5f55fc2f&"
import script from "./landingPages.vue?vue&type=script&lang=js&"
export * from "./landingPages.vue?vue&type=script&lang=js&"
import style0 from "./landingPages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "landingPages.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {
  VFlex,
  VLayout,
  VProgressLinear,
})
